var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaIcSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 41C33.3888 41 41 33.3888 41 24C41 14.6112 33.3888 7 24 7C14.6112 7 7 14.6112 7 24C7 33.3888 14.6112 41 24 41ZM24 45C35.598 45 45 35.598 45 24C45 12.402 35.598 3 24 3C12.402 3 3 12.402 3 24C3 35.598 12.402 45 24 45Z",
    fill: "#00C1CA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.6966 14.8974C36.5816 15.5583 36.7634 16.8115 36.1026 17.6966L25.5649 31.8095C24.5017 33.2335 22.4407 33.4263 21.1318 32.2243L12.1472 23.9731C11.3336 23.2259 11.2798 21.9607 12.0269 21.1472C12.7741 20.3336 14.0393 20.2798 14.8528 21.0269L23.0221 28.5293L32.8974 15.3034C33.5583 14.4184 34.8115 14.2366 35.6966 14.8974Z",
    fill: "#00C1CA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaIcSuccess);
export default __webpack_public_path__ + "static/media/pa_ic_success.aa60c4e30b0d35dc17235d5c48630a68.svg";
export { ForwardRef as ReactComponent };